globalThis.EmojiPicker = (function () {
  function EmojiPicker($html) {
    this.$html = $html;

    this.popup = null;
    this.bindEvents();
    this.createPopup();
  }

  EmojiPicker.init = function () {
    $('.emoji-picker').each(function () {
      new EmojiPicker($(this));
    })
  }

  EmojiPicker.prototype = {
    bindEvents: function () {
      const self = this;

      this.$html.each(function () {
        const $input = $(this);

        $input.on('input keyup', function (e) {
          if (['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(e.key)) {
            return;
          }

          const matchData = self.getEmojiMatchBeforeCursor($input[0]);

          if (matchData) {
            const coords = self.getEmojiTriggerPosition($input[0], matchData.startIndex);
            self.showSuggestions(matchData.keyword, coords, $input);
          } else {
            self.hidePopup();
          }
        });

        $input.on('keydown', function (e) {
          if (!self.popup.is(':visible')) return;

          if (e.key === 'ArrowDown') {
            e.preventDefault();
            self.moveSelection(1);
          }
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            self.moveSelection(-1);
          }
          if (e.key === 'Enter') {
            e.preventDefault();
            self.selectCurrent($input);
          }
          if (e.key === 'Escape') {
            self.hidePopup();
          }
        });
      });
    },
    createPopup: function () {
      this.popup = $('<div id="emoji-suggestions"></div>').css({ display: 'none' }).appendTo('body');
    },
    showSuggestions: function (keyword, coords, $input) {
      const self = this;
      const results = Object.entries(assets.emojiMap)
        .filter(([key]) => key.includes(keyword))
        .slice(0, 10);

      if (results.length === 0) {
        this.hidePopup();
        return;
      }

      const html = results.map(([key, emoji], i) =>
        `<div class="emoji-option${i === 0 ? ' selected' : ''}" data-code="${key}">${emoji} :${key}:</div>`
      ).join('');

      this.popup.html(html).css({ display: 'block' });

      const popupHeight = this.popup.outerHeight();
      const offset = 6;

      this.popup.css({
        top: coords.top - popupHeight - offset + 'px',
        left: coords.left + 'px'
      });

      this.popup.off('click').on('click', '.emoji-option', function () {
        const code = $(this).data('code');
        const emoji = assets.emojiMap[code];
        const val = $input.val();
        const newVal = val.replace(/:([a-z0-9_+-]{1,30})$/i, emoji);
        $input.val(newVal);
        self.hidePopup();
        $input.focus();
      });
    },
    hidePopup: function () {
      this.popup.hide();
    },
    moveSelection: function (direction) {
      const items = this.popup.find('.emoji-option');
      const current = items.filter('.selected');
      let next = direction > 0
        ? current.next('.emoji-option')
        : current.prev('.emoji-option');

      if (next.length) {
        current.removeClass('selected');
        next.addClass('selected');

        next[0].scrollIntoView({ block: 'nearest' });
      }
    },
    selectCurrent: function ($input) {
      const selected = this.popup.find('.emoji-option.selected');
      if (!selected.length) return;

      const emoji = assets.emojiMap[selected.data('code')];
      const match = this.getEmojiMatchBeforeCursor($input[0]);
      if (!match) return;

      this.replaceEmojiShortcode($input, emoji, match.startIndex);
      this.hidePopup();
      $input.focus();
    },
    replaceEmojiShortcode: function ($input, emoji, startIndex) {
      const el = $input[0];
      const cursor = el.selectionStart;
      const value = el.value;

      const before = value.substring(0, startIndex);
      const after = value.substring(cursor);
      const newVal = before + emoji + after;

      $input.val(newVal);

      const newCursor = before.length + emoji.length;
      el.setSelectionRange(newCursor, newCursor);
    },
    getEmojiMatchBeforeCursor: function (el) {
      const value = el.value;
      const cursorPos = el.selectionStart;

      const beforeCursor = value.slice(0, cursorPos);

      const match = beforeCursor.match(/:([a-z0-9_+-]{1,30})$/i);

      if (!match) return null;

      return {
        keyword: match[1],
        startIndex: match.index
      };
    },
    getEmojiTriggerPosition: function (el, index) {
      const value = el.value;

      const mirrorDiv = document.createElement('div');
      document.body.appendChild(mirrorDiv);

      const style = window.getComputedStyle(el);
      const props = [
        'boxSizing', 'width', 'height',
        'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
        'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
        'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch',
        'fontSize', 'fontSizeAdjust', 'lineHeight',
        'fontFamily', 'letterSpacing', 'wordSpacing',
        'textAlign', 'textTransform', 'textIndent'
      ];

      props.forEach(prop => {
        mirrorDiv.style[prop] = style[prop];
      });

      const rect = el.getBoundingClientRect();
      mirrorDiv.style.position = 'absolute';
      mirrorDiv.style.top = rect.top + window.scrollY + 'px';
      mirrorDiv.style.left = rect.left + window.scrollX + 'px';
      mirrorDiv.style.visibility = 'hidden';
      mirrorDiv.style.whiteSpace = 'pre-wrap';
      mirrorDiv.style.width = el.clientWidth + 'px';
      mirrorDiv.style.overflow = 'hidden';

      mirrorDiv.textContent = value.substring(0, index);

      const span = document.createElement('span');
      span.textContent = '\u200b';
      mirrorDiv.appendChild(span);

      const spanRect = span.getBoundingClientRect();
      document.body.removeChild(mirrorDiv);

      return {
        top: spanRect.top,
        left: spanRect.left
      };
    }
  };

  return EmojiPicker;
})();
